var _g, _polygon, _polygon2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKeypadHide = function SvgKeypadHide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.2 20",
    style: {
      enableBackground: "new 0 0 20.2 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M10,14.2c-1.6,0-2.9,1.3-2.9,2.9S8.4,20,10,20s2.9-1.3,2.9-2.9S11.7,14.2,10,14.2z M10,18.8 c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7C11.8,18.1,11,18.8,10,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M17.3,7.2c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9C20.2,8.5,18.9,7.2,17.3,7.2z M17.3,11.8 c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S19,9.2,19,10.1S18.2,11.8,17.3,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M2.9,14.2c-1.6,0-2.9,1.3-2.9,2.9S1.3,20,2.9,20s2.9-1.3,2.9-2.9S4.5,14.2,2.9,14.2z M2.9,18.8 c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7C4.6,18.1,3.9,18.8,2.9,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M17.3,5.8c1.6,0,2.9-1.3,2.9-2.9S18.9,0,17.3,0s-2.9,1.3-2.9,2.9S15.7,5.8,17.3,5.8z M17.3,1.2 C18.2,1.2,19,2,19,2.9s-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7S16.3,1.2,17.3,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M17.2,14.2c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S18.8,14.2,17.2,14.2z M17.2,18.9 c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S18.1,18.9,17.2,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M2.9,7.1C1.3,7.1,0,8.4,0,10s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S4.5,7.1,2.9,7.1z M2.9,11.7 c-0.9,0-1.7-0.8-1.7-1.7S2,8.3,2.9,8.3S4.6,9.1,4.6,10S3.9,11.7,2.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M10.1,0C8.5,0,7.2,1.3,7.2,2.9s1.3,2.9,2.9,2.9S13,4.5,13,2.9S11.7,0,10.1,0z M10.1,4.6 c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S11,4.6,10.1,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M2.9,0C1.3,0,0,1.3,0,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S4.5,0,2.9,0z M2.9,4.6C2,4.6,1.2,3.9,1.2,2.9 S2,1.2,2.9,1.2S4.6,2,4.6,2.9S3.9,4.6,2.9,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M10,7.1c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S11.7,7.1,10,7.1z M10,11.7 c-0.9,0-1.7-0.8-1.7-1.7S9.1,8.3,10,8.3s1.7,0.8,1.7,1.7C11.8,10.9,11,11.7,10,11.7z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#698DB0",
    points: "19.4,20.7 -0.7,1.1 0.7,-0.3 20.8,19.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;",
    points: "20.5,19.6 0.4,0 0.7,-0.3 20.8,19.3 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeypadHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keypad-hide.4c1c897b.svg";
export { ForwardRef as ReactComponent };